class StringUtils {

    static stripHTMLTags(string) {
        return string.replace(/<\/?[^>]+(>|$)/g, "");
    }

    static stringToNumericArray(str, delimiter) {
        let d = delimiter ? delimiter : ","
        let arr = str.split(d);
        let result = [];
        arr.map((s) => {
            result.push(parseInt(s))
        })
        return result;
    }

}

export default StringUtils